<template>
  <div class="glitch">
    <div class="glitch__img"></div>
    <div class="glitch__img"></div>
    <div class="glitch__img"></div>
    <div class="glitch__img"></div>
  </div>
</template>

<script>
export default {};
</script>
